export const PLAN_LIST = [
  {
    id: "free", name: "Free", price: 0, tag: "Start here",
    features: ["Full artist page / link-in-bio", "1 track on air in the night rotation (00–07)", "+1 daytime play every week", "Both Weekly Charts", "Basic report: plays, listeners, Flames"],
  },
  {
    id: "artist", name: "Artist", price: 4.99, yearly: 49.9, tag: "Most artists",
    features: ["Up to 5 tracks in rotation, all day", "60 guaranteed plays / month", "Full report with reactions and page visits", "On Air Now story cards", "Highlighted in the showcase"],
  },
  {
    id: "pro", name: "Pro", price: 12.99, yearly: 129.9, tag: "Maximum reach",
    features: ["Everything in Artist", "150 guaranteed plays / month, 30 in prime time (20–23)", "Unlimited tracks", "Pro badge + featured on the home page", "1 written review every month"],
  },
];

export const SERVICE_LIST = [
  { id: "premiere", name: "Radio Premiere", price: 9, desc: "Your new release announced and aired as a premiere, right after the current track." },
  { id: "review", name: "Written Review", price: 15, desc: "An honest review of your track published in the magazine, ready to share." },
  { id: "cover", name: "Home Cover — 7 days", price: 19, desc: "You on the home page cover for a full week, seen by every listener." },
  { id: "interview", name: "Published Interview", price: 25, desc: "A full interview in the magazine, linked from your artist page." },
];
